import { el, list, mount, unmount } from 'redom';

import SearchResultRow from './search-result-row';

class SearchResultsList {

  constructor() {

    this.onClick = null;
    this.resultsList = null;

    this.el = el('.search-results-list');

  }

  setOnClick(onClick) {

    this.onClick = onClick;

  }

  update(results) {

    if (this.resultsList !== null) {
      unmount(this.el, this.resultsList);
      this.resultsList = null;
    }

    this.resultsList = list('.search-results-list-inner', SearchResultRow);

    mount(this.el, this.resultsList);

    this.resultsList.update(results, {
      onClick: this.onClick
    });

  }

}

export default SearchResultsList;